<template>
  <template v-if="isDesktop">
    <TsModal
      v-model:visible="stockStore.checkStockModalVisible"
      :dataTestid="props.dataTestid + '-main-wrapper'"
      append-class="overflow-hidden bg-white"
    >
      <template #modal-content>
        <TsCheckStockAction
          v-bind="$attrs"
          :product="props.product"
          :data-testid="props.dataTestid + '-action'"
        />
      </template>
    </TsModal>
  </template>
  <template v-if="isMobile">
    <TsDrawer
      v-model:visible="stockStore.checkStockModalVisible"
      :dataTestid="props.dataTestid + '-main-wrapper'"
      position="bottom"
      append-class="overflow-hidden bg-white"
    >
      <TsCheckStockAction
        v-bind="$attrs"
        :product="props.product"
        :data-testid="props.dataTestid + '-action'"
      />
    </TsDrawer>
  </template>
</template>

<script setup lang="ts">
import type { Product } from "~/types/ecom/product/product.type";

const TsDrawer = defineAsyncComponent(
  () => import("~/components/organisms/TsDrawer.vue")
);

const TsCheckStockAction = defineAsyncComponent(
  () => import("~/components/organisms/TsCheckStockAction.vue")
);

const { isMobile, isDesktop } = useDevice();

const { useStockStore } = await import("~/stores/stock.store");
const stockStore = useStockStore();

type Props = {
  product: Product;
  dataTestid: string;
};

const props = withDefaults(defineProps<Props>(), {});

defineOptions({
  inheritAttrs: false
});
</script>
